import React, { useState, useEffect } from "react"
import { toaster } from '../../../config'
import { logActivity } from '../../../services/utilService'
import { getVideo, saveVideo } from "../../../services/formService"
import CustomLoader from "../../common/Loader"

const WVideo = ({Widget_ID, Form_ID, Project_ID, onRemove}) => {
    const [loading, setLoading] = useState(true)
    const [videoTitle, setVideoTitle] = useState('')
    const [videoUrl, setVideoUrl] = useState('')
    const [withinRow, setWithinRow] = useState(false)

    useEffect(() => {
        const getVideoData = async() => {
            const { data } = await getVideo(Widget_ID);
            if (data.length !== 0) {
                setVideoTitle(data[0].Title_Text || '')
                setVideoUrl(data[0].Video_URL || '')
                setWithinRow(data[0].WithinRow || false)
            }
        }
        getVideoData()
        .then(() => setLoading(false))
        // eslint-disable-next-line
    }, [])

    const onSave = async() => {
        const { data } = await saveVideo(videoTitle, videoUrl, Widget_ID, withinRow)
        if (data.includes("Error")) {
            toaster('error', data)
            logActivity('/formBuilder', 'WIDGET_VIDEO_FAILED')
        } else {
            toaster('success', 'Widget saved.')
            logActivity('/formBuilder', 'WIDGET_VIDEO_SAVE_SUCCESS')
        }
    }

    if (loading) {
        return <CustomLoader loading={loading} />
    }

    return <>
        <div className="form-group">
            <label htmlFor={"videoTitle" + Widget_ID}>Title</label>
            <input
                className="form-control"
                id={"videoTitle" + Widget_ID}
                type="text"
                name="videoTitle"
                value={videoTitle}
                onChange={(e) => setVideoTitle(e.target.value)}
            />
        </div>
        <div className="form-group">
            <label htmlFor={"videoUrl" + Widget_ID}>Url</label>
            <input
                className="form-control"
                id={"videoUrl" + Widget_ID}
                type="text"
                name="videoUrl"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
            />
        </div>
        <div className='row'>
            <div className="col-md-4 form-group">
                <div className="custom-control custom-switch mt-n2">
                    <input
                        type="checkbox"
                        name='Include_RowWidget'
                        id={'rowSwitch' + Widget_ID}
                        className="custom-control-input"
                        checked={withinRow}
                        value={withinRow}
                        onChange={(e) => setWithinRow(!withinRow)}
                    />
                    <label htmlFor={'rowSwitch' + Widget_ID} className="custom-control-label">
                        Include in row widget
                    </label>
                </div>
            </div>
        </div>
        <div className="d-flex justify-content-end mt-2">
            <button
                className="btn btn-outline-primary mr-2"
                onClick={onSave}
            >
                Save
            </button>
            <button
                className="btn btn-outline-danger"
                onClick={() => onRemove(Widget_ID)}
            >
                Delete
            </button>
        </div>
    </>
}

export default WVideo